

























import UserRequired from "../UserRequired";
import {Component, Inject} from "vue-property-decorator";
import {
  NotificationConfig, NotificationSensorAndConfigId,
} from "@/modules/notificationmodels";
import Api from "@/components/start/Api";
import NotificationConfigDisplaycard from "@/components/start/NotificationConfigDisplaycard.vue";
import NotificationConfigAddDialog from "@/components/start/NotificationConfigAddDialog.vue";
import rd from "@/modules/vRoutedefs";


@Component({
  components: {
    "at-config-display": NotificationConfigDisplaycard,
    "at-config-add": NotificationConfigAddDialog,
  }
})
export default class NotificationConfigPage extends UserRequired {
  @Inject()
  api!: Api;

  configs: NotificationConfig[] = [];
  working = false;

  showAddDlg = false;

  readonly docTo = rd.docs.notifications.path;

  async onConfigAdded() {
    this.emitSnack(`Varsling lagt til`);
    await this.loadConfigs();
  }

  async loadConfigs() {
    this.working = true;
    try {
      this.configs = await this.api.listNotificationConfigs();
    } finally {
      this.working = false;
    }
  }

  async removeConfig(configId: number) {
    this.working = true;
    try {
      await this.api.removeNotificationConfig(configId);
      this.configs = await this.api.listNotificationConfigs();
      this.emitSnack(`Varsling fjernet`);
    } finally {
      this.working = false;
    }
  }

  async doSave(config: NotificationConfig) {
    this.working = true;
    try {
      await this.api.saveNotificationConfig(config);
      this.configs = await this.api.listNotificationConfigs();
      this.emitSnack(`Varsling endret`);
    } finally {
      this.working = false;
    }
  }

  async addSensor(sensorAndId: NotificationSensorAndConfigId) {
    this.working = true;
    try {
      await this.api.addNotificationSensor(sensorAndId.configId, sensorAndId.sensor);
      this.configs = await this.api.listNotificationConfigs();
      this.emitSnack(`Rapport lagt til`);
    } finally {
      this.working = false;
    }
  }

  async removeSensor(sensorId: number) {
    await this.api.removeNotificationSensor(sensorId);
    this.configs = await this.api.listNotificationConfigs();
    this.emitSnack(`Rapport fjernet`);
  }

  get canAdd() {
    return this.user.usersCompanies().length > 0;
  }

  created() {
    this.loadConfigs();
  }
}

